import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';

import { ButtonIconComponent } from '../../components/button/button-icon.component';
import { ButtonComponent } from '../../components/button/button.component';
import { LoadingComponent } from '../../components/loading/loading.component';
import { Table } from '../../domain/models/table';
import { TableService } from '../../domain/services/table.service';
import { ReceiptComponent } from './receipt/receipt.component';
import { PaymentDone } from '../../domain/models/payment-done';

@Component({
    selector: 'app-show-receipts',
    imports: [
        CommonModule,
        LoadingComponent,
        ButtonComponent,
        ButtonIconComponent,
        ReceiptComponent,
    ],
    templateUrl: './show-receipts.component.html',
    styleUrl: './show-receipts.component.scss'
})
export class ShowReceiptsComponent {
  uuid: string;
  loading: boolean = false;
  tableSubscription: Subscription;
  table: Table;
  receipts: PaymentDone[];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private tableService: TableService,
  ) {
    this.uuid = String(this.route.snapshot.paramMap.get('uuid'));
    this.loading = true;
    
    this.table = this.tableService.getTable();

    if(!this.table) {
      this.tableService.loadTable(this.uuid)
    } else {
      this.receipts = this.tableService.getReceipts()
    }
    
    if(!this.tableSubscription) {
      this.tableSubscription = this.tableService.$openedTable.subscribe((table: Table | null) => {
        if(table) {
          this.table = table;
          this.receipts = this.tableService.getReceipts();
          this.loading = false;
        }
      })
    }
  }

  handleBack() {
    this.router.navigate([`${this.uuid}`])
  }
}
